import { mergePositional } from './positional';

// Groups are replaced like any positional array: only when the group count matches, then each
// group's tiles only when their count matches.
const mergeResponseGroups = (english, translated) =>
  Array.isArray(english) && Array.isArray(translated) && english.length === translated.length
    ? english.map((group, i) => ({
        ...group,
        title: translated[i].title ?? group.title,
        responses: mergePositional(group.responses, translated[i].responses),
      }))
    : english;

// Only the title keys of ui_style merge.
export const mergeClassification = (jsonData, translated) => {
  const uiStyle = translated.ui_style || {};
  return {
    ...jsonData,
    stimulus: translated.stimulus ?? jsonData.stimulus,
    possible_responses: mergePositional(jsonData.possible_responses, translated.possible_responses),
    possible_response_groups: mergeResponseGroups(jsonData.possible_response_groups, translated.possible_response_groups),
    ui_style: jsonData.ui_style && {
      ...jsonData.ui_style,
      column_titles: mergePositional(jsonData.ui_style.column_titles, uiStyle.column_titles),
      row_titles: mergePositional(jsonData.ui_style.row_titles, uiStyle.row_titles),
      row_header: uiStyle.row_header ?? jsonData.ui_style.row_header,
    },
  };
};
